import { UserRole } from "../../models/UserInfoModel";
export let Step = /*#__PURE__*/function (Step) {
  Step["First"] = "first";
  Step["Second"] = "second";
  Step["QBO"] = "qbo";
  Step["QBOSetup"] = "qboSetup";
  Step["Saving"] = "Saving";
  return Step;
}({});
export let ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["General"] = "general";
  ErrorType["Stripe"] = "stripe";
  return ErrorType;
}({});
export function isValidWorkspace(workspace) {
  return workspace.features.accountsPayable && [UserRole.Owner, UserRole.Admin, UserRole.Member].includes(workspace.role) || workspace.features.accountsReceivable && workspace.setupCompleted;
}